import { MERGE_TAG_IDENTIFIER_CHARSET } from "./parse";

// Product/cart merge tags that don't work in blasts (broadcasts don't receive product data)
// Matches: {{ item.* }}, {{ cart.* }}, {{ tile_data.* }}, {{ last_item.* }}, {{ other_item.* }}, {{ other_items.* }}
const PRODUCT_CART_KEYWORDS =
  "item|cart|tile_data|last_item|other_item|other_items";
const PRODUCT_CART_PATTERN = new RegExp(
  `\\{\\{\\s*(?:${PRODUCT_CART_KEYWORDS})(?:\\.${MERGE_TAG_IDENTIFIER_CHARSET}+)?\\s*(?:\\|[^}]*)?\\}\\}`,
  "gi",
);

/**
 * True when content uses canonical product/cart merge tags that only resolve in
 * a product context (`{{ item.* }}`, `{{ tile_data.* }}`, `{{ cart.* }}`, etc.).
 *
 * This is the agnostic primitive. Features that also support authoring aliases
 * compose those on top of this (see Text Composer `hasProductMergeTag`).
 */
export function hasProductContextTags(
  contentText: string | null | undefined,
): boolean {
  if (!contentText) return false;
  PRODUCT_CART_PATTERN.lastIndex = 0;
  return PRODUCT_CART_PATTERN.test(contentText);
}
